import React from 'react';
import { useNotification } from '../providers/NotificationProvider';
import { Snackbar } from 'neon-design-system';


const NotificationMessage = (): JSX.Element => {
	const { message, clearMessage, messageType } = useNotification();

	return (
		<Snackbar
			open={!!message}
			message={message ?? ''}
			type={messageType || 'info'}
			onClose={clearMessage}
			onUndo={undefined}
		/>
	);
};

export default NotificationMessage;
